import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.3_@babel+core@7.24.5_babel-plugin-macros@3.1.0_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.77.0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["HomeButton"] */ "/vercel/path0/packages/wello/src/app/_components/HomeButton.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/wello/src/app/not-found.module.scss");
